
import common from '@/utils/common';
import * as Cookies from 'js-cookie';
export default {
  mixins: [common],
  name: 'login',
  auth: 'guest',
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      errors: {},
      channel: false,
      isClient: false,
    };
  },
  methods: {
    login() {
      this.$auth
        // .loginWith('laravelSanctum', { data: this.form })
        .loginWith('local', { data: this.form }) // 'laravelSanctum' → JWT 전략명('local' 혹은 설정한 이름)
        .then((response) => {
          if (process.client) {
            if (window.loginChannel) {
              // response.data 구조가 JWT에서는 토큰 + user 정보가 담기므로 적절히 수정
              window.loginChannel.postMessage(
                JSON.stringify({ success: response }),
              );
            }
          }
          Cookies.set('auth_token', response.data.token, {
            expires: 365, // 7일 동안 쿠키 유지
            sameSite: 'strict', // CSRF 공격 방지
            // secure: process.env.NODE_ENV === 'production', // HTTPS 환경에서만 전송
          });
          // const cookie = useCookie('auth_token', {
          //   maxAge: 60 * 60 * 24 * 7,
          //   sameSite: true,
          //   secure: process.env.NODE_ENV === 'production', // 개발에서는 false : safari, firefox에서 쿠키가 생성안되는 현상 방지
          // });
          // cookie = token;
          this.$auth.setUser(response.data.user);
          this.$store.commit('setUserToken', response.data.token);
          // this.$auth.user 객체가 JWT 로그인 후에 현재 로그인 사용자 정보 담음
          // 예: this.$auth.user?.district 가 백엔드에서 보내주는 사용자 정보 내 필드명과 일치해야 함
          this.$store.commit('changeDistrict', this.$auth.user?.district);

          this.$router.push(
            this.$auth.$state.redirect ? this.$auth.$state.redirect : '/',
          );
        })
        .catch((e) => {
          console.log(e, 3333);
          if (e.response.data.errors) this.errors = e.response.data.errors;
        });
    },
    loginFlutter(data) {
      this.fromFlutter = data;
      this.$auth
        .loginWith('local', { data: this.form })
        .then((response) => {
          this.$auth.setUser(response.data.user);
          this.$store.commit('setUserToken', response.data.token);
          this.$store.commit('changeDistrict', this.$auth.user?.district);
          this.$router.push(
            this.$auth.$state.redirect ? this.$auth.$state.redirect : '/',
          );
          if (window.loginChannel)
            window.loginChannel.postMessage(
              JSON.stringify({ success: response.data }),
            );
        })
        .catch((e) => {
          console.log(e.response.data.errors, 3333);
          if (window.loginChannel)
            window.loginChannel.postMessage(
              JSON.stringify({ error: e.response }),
            );

          if (e.response.data.errors) this.errors = e.response.data.errors;
        });
    },
    async middleMethod(message) {
      this.fromFlutter = JSON.stringify(message);

      if (typeof message == 'object') {
        await this.loginFlutter(message);
      }
    },
  },
  mounted() {
    window.loginFromFlutter = (message) => {
      this.middleMethod(message);
    };
    if (process.client) {
      this.isClient = true;
    }
    if (window.loginChannel) {
      this.channel = true;
    }
  },
};
